import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EvaluationFoodsModel } from './EvaluationFoodsModel';

@Injectable({
  providedIn: 'root'
})
export class EvaluationFoodsService {

  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 

 GetAllByFoodIdId(foodId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}EvaluationFoods/GetAllByFoodIdId/${foodId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

insert(payload: EvaluationFoodsModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}EvaluationFoods/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
}
